"use client";

import { Tabs, Button, Card, Table, Grid, Popover } from "antd";
import {
  EditOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  PlusOutlined,
  SolutionOutlined,
  ScissorOutlined,
  ClockCircleOutlined,
  SearchOutlined,
  CloseOutlined,
  MedicineBoxOutlined,
  MoreOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import { Row, Col, Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { bookAppointment } from "../../services/receptionist/book appointment/bookappointment";
import { useAuth } from "../../services/authentication_API/authService";
import { Prev } from "react-bootstrap/esm/PageItem";
import { getCaseSheetData } from "../../services/doctor/consultant/consultant";
import VitalsDisplay from "../patients/Vitals_display";
import { getVitals } from "../../services/doctor/vitals/vitals";
import TemplateSelectionModal from "../certificate/TemplateSelectionModal";
import { getPremedicalHistoryData } from "../../services/doctor/medical_history/medicalHistory";
import MedicalHistory from "../consultant/medicalHistory";
import BillPaymentModal from "../Billong/BillPaymentModal";
import ReportHistoryModal from "../reports/ReportHistoryModal";
const { useBreakpoint } = Grid;

export default function PatientDetails({
  patient,
  onVitalsClick,
  appoimentBooked,
}) {
  const { userData } = useAuth();
  const { TabPane } = Tabs;
  const screens = useBreakpoint();
  const [startConsult, setStartConsult] = useState(false);
  const [followUpConsult, setFollowUpConsult] = useState(false);
  const [certificate,setCertificate]=useState(false);
  const navigate = useNavigate();
  console.log("appointment created : ", appoimentBooked);
  const [caseSheets, setCaseSheets] = useState([]); // Array of case sheets
  const [loading, setLoading] = useState(false);
  const [caseSheetIndex, setCaseSheetIndex] = useState(-1); // Current index
  const [showVitals, setShowVitals] = useState(false);
  const [selectedCaseSheet, setSelectedCaseSheet] = useState(null);
  const [vitalsData, setVitalsData] = useState(null);
  const [vitalRefreshFlag, setVitalRefreshFlag] = useState(false);
  const today = dayjs().format("YYYY-MM-DD");
  const [medicalHistory, setMedicalHistory] = useState([]);
  const [showMedicalHistory, setShowMedicalHistory] = useState(false);
  const [bill, setBill]=useState(false);
  const [reportHistory, setReportHistory]=useState(false);
  

  const handleShowVitals = () => {
    if (caseSheets.length > 0 && caseSheets[caseSheetIndex]) {
      console.log("Case Sheets Array:", caseSheets[caseSheetIndex]);
      setSelectedCaseSheet(caseSheets[caseSheetIndex]);
      console.log("Selected Case Sheet for Vitals:", selectedCaseSheet);
      setShowVitals(true);
    } else {
      // Optionally show a message: "No case sheet data available"
      console.warn("No case sheet data available for vitals modal.");
    }
  };
  useEffect(() => {
    const run = async () => {
      if (appoimentBooked == false) {
        console.log("booking appointment : false");
        console.log("doctor id :", userData?.id);
        let response = null;
        try {
          const appointmentData = {
            doctor_id: userData?.id,
            patient_id: patient?.patient?.id,
            appointment_date: dayjs().format("YYYY-MM-DD"),
            appointment_time: dayjs().format("HH:mm"),
            status: "Consult",
            slot_number: 0,
            shift_id: "0",
          };

          const result = await bookAppointment(appointmentData);

          if (result?.success) {
            response = result?.data;
            console.log("Appointment booked successfully:", response);
            navigate("/start-consult", {
              state: {
                doctorID: response?.doctor_id,
                appointmentID: response?.id,
                followUpAppointmentID: null,
              },
            });
          } else {
            const errors = result?.error;
            console.error("Booking error:", errors);
          }
        } catch (error) {
          console.error("Error booking appointment:", error);
        }
      } else {
        console.log("booking appointment : true");
        navigate("/start-consult", {
          state: {
            doctorID: patient?.doctor_id,
            appointmentID: patient?.id,
            followUpAppointmentID: null,
          },
        });
      }
    };
    const run2 = async () => {
      if (appoimentBooked == false) {
        console.log("booking appointment : false");
        console.log("doctor id :", userData?.id);
        let response = null;
        try {
          const appointmentData = {
            doctor_id: userData?.id,
            patient_id: patient?.patient?.id,
            appointment_date: dayjs().format("YYYY-MM-DD"),
            appointment_time: dayjs().format("HH:mm"),
            status: "Consult",
            slot_number: 0,
            shift_id: "0",
          };

          const result = await bookAppointment(appointmentData);

          if (result?.success) {
            response = result?.data;
            console.log("Appointment booked successfully:", response);
            navigate("/start-consult", {
              state: {
                doctorID: response?.doctor_id,
                appointmentID: response?.id,
                followUpAppointmentID: currentCase?.id,
              },
            });
          } else {
            const errors = result?.error;
            console.error("Booking error:", errors);
          }
        } catch (error) {
          console.error("Error booking appointment:", error);
        }
      } else {
        console.log("booking appointment : true");
        navigate("/start-consult", {
          state: {
            doctorID: patient?.doctor_id,
            appointmentID: patient?.id,
            followUpAppointmentID: currentCase?.id,
          },
        });
      }
    };
    if (startConsult) {
      setStartConsult(false);
      run();
    }
    if (followUpConsult) {
      setFollowUpConsult(false);
      run2();
    }
  }, [startConsult, followUpConsult]);

  // Responsive font sizes
  const getFontSize = (base, sm, xs) => {
    if (screens.xs) return xs;
    if (screens.sm) return sm;
    return base;
  };

  const fetchCaseSheetData = async () => {
    try {
      setLoading(true);
      const result = await getCaseSheetData(patient?.patient?.id);
      if (result.success) {
        // result.data should be an array
        const filteredCaseSheets = (result.data || []).filter((caseSheet) => {
  // If the document type is NOT "RX", we don't filter it out (return true)
  if (caseSheet.casesheet_document_type !== "RX") {
    return true;
  }

  // If it IS "RX", apply your existing filtering logic
  const isToday = dayjs(caseSheet.appointment_date).format("YYYY-MM-DD") === today;
  const isNotFinished = caseSheet.status !== "Done" && caseSheet.status !== "Hold";

  // Return false (filter out) ONLY if it's today AND not Done/Hold
  return !(isToday && isNotFinished);
});

        setCaseSheets(filteredCaseSheets);
        console.log("Casesheet Data:", result.data);
        setCaseSheetIndex(0); // Always start at the latest (or first)
      } else {
        setCaseSheets([]);
        setCaseSheetIndex(0);
        console.error(
          "Error:",
          result.error || "Failed to fetch casesheet data"
        );
      }
    } catch (err) {
      setCaseSheets([]);
      setCaseSheetIndex(0);
      console.error("Exception:", err.message);
    } finally {
      setLoading(false);
    }
  };
     const fetchPreMedicalHistory = async () => {
      try {
        const result = await getPremedicalHistoryData(patient?.patient?.id);

        if (!result?.success) return;

        const { consult_medical_histories } = result.data || {};
        setMedicalHistory(consult_medical_histories);
      } catch (error) {
        console.error("Error fetching pre-medical history:", error);
      }
    };
  useEffect(() => {
    fetchCaseSheetData();
    fetchPreMedicalHistory();
  }, [patient]);
  const currentCase = caseSheets[caseSheetIndex] || {};
  console.log("Current Case:", currentCase);

  useEffect(() => {
    const fetchData = async () => {
      if (currentCase?.id && currentCase?.casesheet_document_type == "RX") {
        try {
          const result = await getVitals(currentCase?.id);
          console.log("Fetched Vitals Data:", result);

          if (result?.success) {
            setVitalsData(result?.data || null);
          } else {
            setVitalsData(null);
          }
        } catch (error) {
          console.error("Error fetching vitals:", error);
        }
      }else
        setVitalsData(null);
    };
    

    fetchData();
  }, [currentCase?.id, vitalRefreshFlag]);

  // ...existing code...
  const vitalLabelStyle = {
    fontSize: screens.xs ? "0.7rem" : "0.75rem",
    minWidth: screens.xs ? "60px" : "80px",
    marginRight: "8px",
    flexShrink: 0,
  };

  const vitalInputStyle = {
    fontSize: screens.xs ? "0.7rem" : "0.875rem",
    maxWidth: screens.xs ? "80px" : "100px",
    height: screens.xs ? "28px" : "32px",
  };

  const vitalUnitStyle = {
    fontSize: screens.xs ? "0.65rem" : "0.75rem",
    minWidth: screens.xs ? "30px" : "40px",
    marginLeft: "8px",
    flexShrink: 0,
  };
  const vitalRowStyle = {
    padding: screens.xs ? "0px 0px 4px 0px" : "0px 0px 6px 0px",
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
  };


  const popoverContent = (
  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
    {/* <Button
      type="text"
      icon={<EditOutlined />}
      onClick={() => {
        // handle edit
        console.log("Edit clicked");
      }}
    >
      Edit
    </Button> */}

    <Button
      type="text"
      icon={<PrinterOutlined />}
      onClick={() => {
        if(caseSheets[caseSheetIndex]?.casesheet_document_type==="RX"){
          // handle print
          navigate("/preview-RX", { state: { formData: caseSheets[caseSheetIndex] } });
        }
        else{
          navigate("/print-certificate", { state: { payload: caseSheets[caseSheetIndex] } });
        }
      }}
    >
      Print
    </Button>
  </div>
);

  return (
    <>
      <div
        className="h-100 d-flex flex-column"
        style={{
          background: "#fff",
          overflow: "hidden",
        }}
      >
        <div className="patient-details d-flex flex-column h-100">
          {/* Action Buttons */}
          <div
            className="action-buttons p-2 d-flex flex-wrap gap-2 border-bottom"
            style={{
              flexShrink: 0,
              background: "#fafafa",
            }}
          >
            <Button
              type="primary"
              style={{
                background: "#2e37a4",
                border: "none",
                fontSize: getFontSize("14px", "13px", "12px"),
                height: getFontSize("36px", "34px", "32px"),
              }}
              onClick={() => setStartConsult(true)}
              icon={<i className="fa fa-stethoscope"></i>}
            >
              Start Consult
            </Button>
            {/* {startConsult &&
            navigate("/start-consult", {
              state: {
                doctorID: patient?.doctor_id ,
                appointmentID:  patient?.id ,
              },
            })} */}
            {caseSheets.length > 0 && currentCase?.casesheet_document_type == "RX"&& (
              <Button
                style={{
                  fontSize: getFontSize("14px", "13px", "12px"),
                  height: getFontSize("36px", "34px", "32px"),
                }}
                onClick={() => setFollowUpConsult(true)}
              >
                Follow-up/Repeat
              </Button>
            )}
            {userData?.module_permissions_list?.Certificates && <Button
              style={{
                fontSize: getFontSize("14px", "13px", "12px"),
                height: getFontSize("36px", "34px", "32px"),
              }}
              onClick={() => setCertificate(true)}
            >
              Certificate
            </Button>}

            <Button
              style={{
                fontSize: getFontSize("14px", "13px", "12px"),
                height: getFontSize("36px", "34px", "32px"),
              }}
              onClick={() => setBill(true)}
            >
              Add Bill / Payment
            </Button>

            <Button
              style={{
                fontSize: getFontSize("14px", "13px", "12px"),
                height: getFontSize("36px", "34px", "32px"),
              }}
              onClick={() => setReportHistory(true)}
            >
              Reports
            </Button>
          </div>

          {/* Scrollable Content */}
          <div
            className="consultation-content p-1"
            style={{
              flex: 1,
              overflowY: "auto",
              overflowX: "hidden",
              scrollbarWidth: "thin",
              scrollbarColor: "#ccc transparent",
              background: "#f9f9f9",
            }}
          >
            <Row className="g-3 h-100">
              {/* Left Column - Vitals and Vaccinations */}
              <Col xs={12} lg={4} className="d-flex flex-column">
                <Card
                  title={
                    <span
                      style={{ fontSize: getFontSize("16px", "15px", "14px") }}
                    >
                      Vitals Trend
                    </span>
                  }
                  extra={
                    <Button
                      type="link"
                      onClick={() => handleShowVitals(true)}
                      style={{ fontSize: getFontSize("14px", "13px", "12px") }}
                    >
                      <RightOutlined />
                    </Button>
                  }
                  style={{
                    width: "100%",
                    cursor: "pointer",
                    minHeight: screens.xs ? "200px" : "250px",
                    marginBottom: "16px", // Adds spacing between the two cards
                  }}
                  onClick={handleShowVitals}
                >
                  <div className="text-center text-muted">
                    {vitalsData ? (
                      <div>
                        {[
                          {
                            name: "Pulse",
                            value: vitalsData.pulse,
                            unit: "/min",
                          },
                          {
                            name: "Systolic",
                            value: vitalsData.systolic,
                            unit: "mmHg",
                          },
                          {
                            name: "Diastolic",
                            value: vitalsData.diastolic,
                            unit: "mmHg",
                          },
                          { name: "SPO2", value: vitalsData.spo2, unit: "%" },
                        ].map((vital, index) => (
                          <div
                            key={index}
                            style={vitalRowStyle}
                            className="d-flex align-items-center mb-2"
                          >
                            <span
                              className="text-muted"
                              style={vitalLabelStyle}
                            >
                              {vital.name}
                            </span>
                            <Form.Control
                              type="text"
                              size="sm"
                              readOnly
                              className="flex-grow-1 mx-2"
                              style={vitalInputStyle}
                              value={vital.value || "--"}
                            />
                            <span className="text-muted" style={vitalUnitStyle}>
                              {vital.unit || "--"}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <>
                        <div className="mb-3 pt-5">
                          <i
                            className="fa fa-heartbeat"
                            style={{
                              fontSize: getFontSize("48px", "40px", "32px"),
                            }}
                          ></i>
                        </div>
                        <p
                          style={{
                            fontSize: getFontSize("14px", "13px", "12px"),
                          }}
                        >
                          No Data
                        </p>
                      </>
                    )}
                  </div>
                </Card>

                <Card
                  title={
                    <span
                      style={{ fontSize: getFontSize("16px", "15px", "14px") }}
                    >
                      Medical History
                    </span>
                  }
                  style={{
                    width: "100%",
                    minHeight: screens.xs ? "150px" : "200px",
                  }}
                  onClick={() => setShowMedicalHistory(true)}
                >
                  <div className="text-muted">
                    <p
                      style={{ fontSize: getFontSize("14px", "16px", "12px") }}
                    >
                      {medicalHistory
                        .filter((cat) => cat.medical_histories?.length > 0)
                        .map((category, idx) => {
                          const isLifestyle =
                            category.name.includes("Lifestyle");

                          return (
                            <>
                              <div
                                key={category.id}
                                style={{
                                  display: "inline-block",
                                  marginRight: "10px",
                                }}
                              >
                                {/* Underlined Category Label */}
                                <span style={{ textDecoration: "underline" }}>
                                  {category.name.replace("H/O ", "")}
                                </span>
                                :{" "}
                                {category.medical_histories.map((item, i) => {
                                  const itemText = <strong>{item.name}</strong>;

                                  // Correctly combine Year and Month: "4 Years 3 Months"
                                  const yearPart = item.since_year
                                    ? `${item.since_year} Years`
                                    : "";
                                  const monthPart = item.since_month
                                    ? `${item.since_month} Months`
                                    : "";
                                  const combinedTime = [yearPart, monthPart]
                                    .filter(Boolean)
                                    .join(" ");
                                  const sinceYear = item.since_when_year || 0;
                                  let details = "";
                                  if (combinedTime) {
                                    // Standard format: "since- 4 Years 3 Months"
                                    details = `since- ${combinedTime}`;
                                  }
                                  if (sinceYear) {
                                    details += details ? `, ` : ``;
                                    details += `Since ${sinceYear}`;
                                  }
                                  if (item?.family_relation) {
                                    details += details ? `, ` : ``;
                                    details += item.family_relation;
                                  }
                                  if (item.note) {
                                    details += details ? `, ` : ``;
                                    details += `${item.note}`;
                                  }

                                  // Family Relation logic

                                  return (
                                    <span key={item.id}>
                                      {itemText}
                                      {details ? `, ${details}` : ""}
                                      {i < category.medical_histories.length - 1
                                        ? ", "
                                        : ""}
                                    </span>
                                  );
                                })}
                                {/* Comma between categories */}
                                {idx <
                                medicalHistory.filter(
                                  (c) => c.medical_histories.length > 0
                                ).length -
                                  1
                                  ? ", "
                                  : ""}
                              </div>
                              <br />
                            </>
                          );
                        })}
                    </p>
                  </div>
                </Card>
              </Col>

              {/* Right Column - Casesheet */}
              <Col xs={12} lg={8}>
                <Card
                  title={
                    <span
                      style={{ fontSize: getFontSize("18px", "17px", "16px") }}
                    >
                      Casesheet
                    </span>
                  }
                  className="h-100"
                  style={{ minHeight: screens.xs ? "400px" : "500px" }}
                  extra={
                    <div style={{ display: "flex", gap: 8 }}>
                      <Popover
                        content={popoverContent}
                        trigger="click"
                        placement="bottomRight"
                      >
                        <Button icon={<MoreOutlined />} size="small" />
                      </Popover>
                      <Button
                        icon={<LeftOutlined />}
                        size="small"
                        disabled={caseSheetIndex === caseSheets.length - 1}
                        onClick={() =>
                          setCaseSheetIndex((i) =>
                            Math.min(i + 1, caseSheets.length - 1)
                          )
                        }
                      />
                      <Button
                        icon={<RightOutlined />}
                        size="small"
                        disabled={caseSheetIndex === 0}
                        onClick={() =>
                          setCaseSheetIndex((i) => Math.max(i - 1, 0))
                        }
                      />
                    </div>
                  }
                >
                  <div
                    style={{
                      height: "100%",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {loading ? (
                      <div className="text-center py-5">Loading...</div>
                    ) : caseSheets.length === 0 ? (
                      <div className="text-center py-5">No Casesheet Data</div>
                    ) : currentCase?.print_html_view == null ||
                      currentCase?.print_html_view === undefined ? (
                      <>
                        <div className="consultation-date mb-3">
                          <h5
                            style={{
                              fontSize: getFontSize("18px", "16px", "15px"),
                            }}
                          >
                            {currentCase.appointment_date
                              ? dayjs(currentCase.appointment_date).format(
                                  "DD MMM YYYY"
                                )
                              : ""}
                            {" - "}
                            {currentCase.appointment_time
                              ? " " + currentCase.appointment_time
                              : ""}
                          </h5>
                        </div>
                        {currentCase.symptoms.length > 0 && (
                          <div className="symptoms-section mb-2">
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              <FileSearchOutlined
                                style={{
                                  color: "#ff4d4f",
                                  fontSize: "15px",
                                  marginRight: "5px",
                                }}
                              />
                              <b>Symptoms: </b>
                            </span>
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              {currentCase.symptoms
                                ?.map((s) => {
                                  // Collect available fields dynamically
                                  const details = [s.note, s.since, s.severity]
                                    .filter(Boolean)
                                    .join(" - ");
                                  return details
                                    ? `${s.name} (${details})`
                                    : s.name;
                                })
                                .join(", ")}
                            </span>
                          </div>
                        )}
                        {currentCase.findings.length > 0 && (
                          <div className="diagnosis-section mb-2">
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              <SearchOutlined
                                style={{
                                  color: "#faad14",
                                  fontSize: "15px",
                                  marginRight: "5px",
                                }}
                              />
                              <b>Findings: </b>
                            </span>
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              {currentCase.findings
                                ?.map((f) => {
                                  // Dynamically build details just like for symptoms
                                  const details = [f.note, f.since, f.severity]
                                    .filter(Boolean)
                                    .join(" - ");
                                  return details
                                    ? `${f.name} (${details})`
                                    : f.name;
                                })
                                .join(", ")}
                            </span>
                          </div>
                        )}
                        {currentCase.diagnosis.length > 0 && (
                          <div className="diagnosis-section mb-2">
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              <SolutionOutlined
                                style={{
                                  color: "#1890ff",
                                  fontSize: "15px",
                                  marginRight: "5px",
                                }}
                              />
                              <b>Diagnosis: </b>
                            </span>
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              {currentCase.diagnosis
                                ?.map((d) => {
                                  // Dynamically include only available fields
                                  const details = [
                                    d.note,
                                    d.location,
                                    d.description,
                                  ]
                                    .filter(Boolean)
                                    .join(" - ");
                                  return details
                                    ? `${d.name} (${details})`
                                    : d.name;
                                })
                                .join(", ")}
                            </span>
                          </div>
                        )}

                        {/* Medicines Table */}
                        {currentCase.medicines.length > 0 && (
                          <div className="diagnosis-section ">
                            {/* <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              <MedicineBoxOutlined
                                style={{
                                  color: "#52c41a",
                                  fontSize: "15px",
                                  marginRight: "5px",
                                }}
                              />
                              <b>Medicine: </b>
                            </span> */}
                            <div
                              className="table-responsive "
                              style={{
                                overflowX: "auto",
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              <div className="">
                                <table className="table table-bordered">
                                  <thead className="table-light">
                                    <tr>
                                      <th
                                        style={{
                                          width: "4%",
                                          textAlign: "center",
                                        }}
                                      >
                                        <strong>Rx</strong>
                                      </th>
                                      <th style={{ width: "26%" }}>
                                        <strong>નામ</strong>
                                      </th>
                                      <th style={{ width: "17%" }}>
                                        <strong>આવર્તન</strong>
                                      </th>
                                      <th style={{ width: "15%" }}>
                                        <strong>સમયગાળો</strong>
                                      </th>
                                      <th style={{ width: "28%" }}>
                                        <strong>નોંધ</strong>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {currentCase?.medicines?.map((med, idx) =>
                                      med.doses?.map((dose, doseIdx) => (
                                        <tr key={`${med.id}-${doseIdx}`}>
                                          {doseIdx === 0 && (
                                            <td
                                              rowSpan={med.doses.length}
                                              className="text-center"
                                            >
                                              {idx + 1}
                                            </td>
                                          )}
                                          {doseIdx === 0 && (
                                            <td rowSpan={med.doses.length}>
                                              {med?.doses[0].type}{" "}
                                              <span
                                                style={{ fontWeight: "bold" }}
                                              >
                                                {med?.name}
                                              </span>
                                            </td>
                                          )}
                                          <td>
                                            {dose?.type_unit_ui == "Default" &&
                                            dose?.default_timing_instruction ? (
                                              <>
                                                {(() => {
                                                  const {
                                                    Breakfast,
                                                    Lunch,
                                                    Dinner,
                                                  } =
                                                    dose.default_timing_instruction ||
                                                    {};
                                                  const q = dose.quantity || 0;
                                                  const breakfastDose =
                                                    Breakfast ? q : 0;
                                                  const lunchDose = Lunch
                                                    ? q
                                                    : 0;
                                                  const dinnerDose = Dinner
                                                    ? q
                                                    : 0;
                                                  const unitString =
                                                    dose?.type &&
                                                    ![
                                                      "Tablet",
                                                      "Capsule",
                                                    ].includes(dose.type)
                                                      ? ` ${dose?.unit || ""}`
                                                      : "";

                                                  return `${breakfastDose}${unitString} - ${lunchDose}${unitString} - ${dinnerDose}${unitString}`.trim();
                                                })()}
                                                <br />
                                              </>
                                            ) : dose?.type_unit_ui ==
                                                "Alternate" &&
                                              dose?.default_timing_instruction ? (
                                              <>
                                                {(() => {
                                                  const timingKeys =
                                                    Object.keys(
                                                      dose?.default_timing_instruction ||
                                                        {}
                                                    );
                                                  const key = timingKeys[0]; // Assume we only care about the first key if multiple exist

                                                  // 2. Check for the specific frequency keys (in English) and return the corresponding Gujarati text
                                                  if (key === "Once") {
                                                    return `${dose?.quantity} ${dose?.unit} દિવસ માં ૧ વાર `; // Once a day
                                                  }
                                                  if (key === "Twice") {
                                                    return `${dose?.quantity} ${dose?.unit} દિવસ માં ૨ વાર`; // Twice a day
                                                  }
                                                  if (key === "Thrice") {
                                                    return `${dose?.quantity} ${dose?.unit} દિવસ માં ૩ વાર`; // Thrice a day
                                                  }
                                                  if (key === "4h") {
                                                    return `${dose?.quantity} ${dose?.unit} દર ૪ કલાકે`; // Every 4 hours
                                                  }
                                                  if (key === "6h") {
                                                    return `${dose?.quantity} ${dose?.unit} દર ૬ કલાકે`; // Every 6 hours
                                                  }
                                                  if (key === "8h") {
                                                    return `${dose?.quantity} ${dose?.unit} દર ૮ કલાકે`; // Every 8 hours
                                                  }
                                                  if (key === "12h") {
                                                    return `${dose?.quantity} ${dose?.unit} દર ૧૨ કલાકે`; // Every 12 hours
                                                  }
                                                  if (key === "48h") {
                                                    return `${dose?.quantity} ${dose?.unit} દર ૨ દિવસે`; // Every 48 hours
                                                  }
                                                  return `${dose?.quantity} ${dose?.unit} ${key}`; // Default to the key if no match found
                                                })()}
                                              </>
                                            ) : (
                                              <>
                                                {dose?.quantity} {dose?.unit}
                                              </>
                                            )}
                                          </td>
                                          <td>
                                            {(() => {
                                              const duration =
                                                dose.duration?.toLowerCase() ||
                                                "";

                                              if (
                                                duration.includes("d") ||
                                                duration.includes("day")
                                              ) {
                                                const num =
                                                  duration.match(/\d+/)?.[0];
                                                return num
                                                  ? `${num} દિવસ`
                                                  : "1 દિવસ";
                                              } else if (
                                                duration.includes("w") ||
                                                duration.includes("week")
                                              ) {
                                                const num =
                                                  duration.match(/\d+/)?.[0];
                                                return num
                                                  ? `${num} અઠવાડિયા`
                                                  : "1 અઠવાડિયા";
                                              } else if (
                                                duration.includes("m") ||
                                                duration.includes("month")
                                              ) {
                                                const num =
                                                  duration.match(/\d+/)?.[0];
                                                return num
                                                  ? `${num} મહિના`
                                                  : "1 મહિના";
                                              } else {
                                                return dose.duration || "N/A";
                                              }
                                            })()}
                                          </td>

                                          <td>
                                            {dose?.type_unit_ui === "Default" // Changed == to the stricter ===
                                              ? (() => {
                                                  const {
                                                    Breakfast,
                                                    Lunch,
                                                    Dinner,
                                                  } =
                                                    dose.default_timing_instruction ||
                                                    {};

                                                  let timingParts = [];

                                                  // Logic for Breakfast
                                                  if (Breakfast) {
                                                    timingParts.push(
                                                      Breakfast === "Before"
                                                        ? "નાસ્તા પહેલા"
                                                        : "નાસ્તા પછી"
                                                    );
                                                  }

                                                  // Logic for Lunch
                                                  if (Lunch) {
                                                    timingParts.push(
                                                      Lunch === "Before"
                                                        ? "બપોરે ભોજન પહેલા"
                                                        : "બપોરે ભોજન પછી"
                                                    );
                                                  }

                                                  // Logic for Dinner
                                                  if (Dinner) {
                                                    timingParts.push(
                                                      Dinner === "Before"
                                                        ? "રાત્રી ભોજન પહેલા"
                                                        : "રાત્રી ભોજન પછી"
                                                    );
                                                  }

                                                  const timingString =
                                                    timingParts.join(", "); // Joins all parts with a comma and space

                                                  // Combine timing and note.
                                                  return (
                                                    timingString +
                                                    (dose.note
                                                      ? `, ${dose.note}`
                                                      : "")
                                                  );
                                                })()
                                              : (() => {
                                                  const timingValues =
                                                    Object.values(
                                                      dose?.default_timing_instruction ||
                                                        {}
                                                    );
                                                  const firstValue =
                                                    timingValues[0];
                                                  let timing = "";

                                                  // Use if/else if for efficient and clear condition checking
                                                  if (
                                                    firstValue === "Before Food"
                                                  ) {
                                                    timing = "ભોજન પહેલા";
                                                  } else if (
                                                    firstValue === "After Food"
                                                  ) {
                                                    timing = "ભોજન પછી";
                                                  } else if (
                                                    firstValue === "With Food"
                                                  ) {
                                                    timing = "ભોજન સાથે";
                                                  } else if (
                                                    firstValue ===
                                                    "Empty Stomach"
                                                  ) {
                                                    timing = "ભૂખ્યા પેટે";
                                                  } else if (
                                                    firstValue === "Bedtime"
                                                  ) {
                                                    timing = "સુવા ના સમયે";
                                                  } else {
                                                    // Default case if the value is not recognized (optional)
                                                    // You can set timing = firstValue or keep it empty
                                                  }

                                                  // Combine timing and note without unnecessary comma handling
                                                  return (
                                                    timing +
                                                    (dose.note && timing
                                                      ? `, ${dose.note}`
                                                      : dose.note || "")
                                                  );
                                                })()}
                                          </td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                        {currentCase.investigations.length > 0 && (
                          <div className="investigations-section mb-2">
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              <FileTextOutlined
                                style={{
                                  color: "#13c2c2",
                                  fontSize: "15px",
                                  marginRight: "5px",
                                }}
                              />
                              <b>Advised Investigations: </b>
                            </span>
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              {currentCase.investigations
                                ?.map((i) => i.name)
                                .join(", ") || "N/A"}
                            </span>
                          </div>
                        )}
                        {currentCase.procedures.length > 0 && (
                          <div className="investigations-section mb-2">
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              <ScissorOutlined
                                style={{
                                  color: "#eb2f96",
                                  fontSize: "15px",
                                  marginRight: "5px",
                                }}
                              />
                              <b>Advised Procedures: </b>
                            </span>
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              {currentCase.procedures
                                ?.map((i) => i.name)
                                .join(", ") || "N/A"}
                            </span>
                          </div>
                        )}
                        {currentCase.instructions.length > 0 && (
                          <div className="investigations-section mb-2">
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              <EditOutlined
                                style={{
                                  color: "#722ed1",
                                  fontSize: "15px",
                                  marginRight: "5px",
                                }}
                              />
                              <b>Instructions: </b>
                            </span>
                            <span
                              style={{
                                fontSize: getFontSize("16px", "15px", "14px"),
                              }}
                            >
                              {currentCase.procedures
                                ?.map((i) => i.name)
                                .join(", ") || "N/A"}
                            </span>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              currentCase?.print_html_view || "<p>No Data</p>",
                          }}
                        />
                      </>
                    )}
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      {showVitals && (
        <VitalsDisplay
          appointment_id={currentCase?.id}
          patient_id={currentCase?.patient_id}
          isVisible={showVitals}
          onClose={() => {
            setShowVitals(false), setVitalRefreshFlag((prev) => !prev);
          }}
          vitaldata={vitalsData}
        />
      )}
      <MedicalHistory
        patientId={patient?.patient?.id}
        open={showMedicalHistory}
        onClose={() => setShowMedicalHistory(false)}
      />
      <TemplateSelectionModal
        visible={certificate}
        onClose={() => setCertificate(false)}
        appointmentData={appoimentBooked ? { patient:patient?.patient, appointmentId:patient?.id } :{ patient:patient?.patient, appointmentId:0 } }

      />

      <BillPaymentModal
        isOpen={bill}
        onClose={() => setBill(false)}
        patientData={patient?.patient}
      />

      <ReportHistoryModal
        isOpenReportHistory={reportHistory}
        onClose={() => setReportHistory(false)}
        patientData={patient?.patient}
      />
    </>
  );
}

PatientDetails.propTypes = {
  patient: PropTypes.object,
  onVitalsClick: PropTypes.func.isRequired,
  appoimentBooked: PropTypes.bool,
};
